import React from "react";
import { useWorkspace } from "@/contexts/WorkspaceContext";
import { useAuth } from "@/contexts/AuthContext";
import QedaraLogo from "@/components/QedaraLogo";
import { ArrowRight, LogOut } from "lucide-react";

// Shown on the base domain when someone belongs to more than one workspace and
// has not picked one yet. Once a choice is stored the app goes straight in, so
// this is a first-login screen, not a gate on every visit.
export default function WorkspaceSelector({ onPick }) {
  const { workspaces } = useWorkspace();
  const { logout, user } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg text-fg p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <QedaraLogo variant="icon" markSize={32} />
          <div className="min-w-0">
            <h1 className="font-bold tracking-tight">Alege un workspace</h1>
            <p className="text-xs text-fg-muted truncate">Conectat ca {user?.email}</p>
          </div>
        </div>

        <ul className="space-y-2" data-testid="workspace-selector">
          {workspaces.map((w) => (
            <li key={w.id}>
              <button
                type="button"
                data-testid={`select-ws-${w.id}`}
                onClick={() => onPick(w.id)}
                className="w-full bg-surface border border-line/10 hover:border-brand/40 transition-colors px-4 py-3 flex items-center gap-3 text-left"
              >
                <div className="w-8 h-8 bg-brand/20 flex items-center justify-center text-sm font-bold flex-shrink-0">
                  {w.name[0]?.toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{w.name}</p>
                  <p className="text-[11px] text-fg-muted mono truncate">
                    {w.subdomain ? `${w.subdomain}.chat.qedara-consulting.uk` : w.slug}
                  </p>
                </div>
                <span className="label-tiny text-fg-muted uppercase flex-shrink-0">{w.role}</span>
                <ArrowRight className="w-4 h-4 text-fg-muted flex-shrink-0" />
              </button>
            </li>
          ))}
        </ul>

        <button
          type="button" onClick={logout}
          className="mt-6 text-xs text-fg-muted hover:text-fg flex items-center gap-1.5"
        ><LogOut className="w-3.5 h-3.5" /> Ieși din cont</button>
      </div>
    </div>
  );
}
